<adapt-context-sidebar-implementation-kit [articleId]="ImplementationKitArticle.ResilientBusinessZones"
                                          context="page"></adapt-context-sidebar-implementation-kit>

@if (isActivated) {
    <div adaptToolbarContent
         alignment="left"
         class="d-flex flex-row gap-2 align-items-center">
        Expand up to
        <button class="btn btn-sm btn-primary"
                adaptButtonIcon="fas fa-fw fa-minus"
                [disabled]="viewOption === 1"
                (click)="onViewChanged(viewOption - 1)"></button>
        <dx-select-box [items]="availableViewOptions"
                       [value]="viewOption"
                       (valueChange)="onViewChanged($event)"
                       displayExpr="text"
                       valueExpr="option"
                       width="120px"></dx-select-box>
        <button class="btn btn-sm btn-primary"
                adaptButtonIcon="fas fa-fw fa-plus"
                [disabled]="viewOption === 0"
                (click)="onViewChanged(viewOption + 1)"
                data-test="view-level-increment"></button>
    </div>

    @if (canConfigureTeam) {
        <div adaptToolbarContent
             alignment="right"
             [ordinal]="0">
            <div class="d-flex align-items-center gap-2">
                <adapt-autosave #autosaveComponent
                                [class.d-none]="!isEditing"
                                [pauseSaving]="pauseSaving"
                                [saveDelay]="0"
                                messagePosition="left"></adapt-autosave>

                <button adaptButton="editLink"
                        [(adaptButtonToggle)]="isEditing"
                        (adaptButtonToggleChange)="onEditToggleChange($event)"
                        data-test="edit-organisation-map">Edit map</button>
            </div>

            <button adaptButtonIcon="add"
                    [adaptBlockingClick]="addTeam"
                    [unsubscribeOnDestroy]="false"
                    data-test="add-team-button">Add group</button>
        </div>
    }

    <adapt-organisation-map-filter adaptToolbarContent
                                   [tooltipContent]="isEditing ? 'Filter options are disabled while editing the organisation map.' : undefined"
                                   [ordinal]="2001"
                                   [disabled]="isEditing"
                                   [isDefaultOverride]="isEditing ? filterBeforeEditingIsDefault : undefined">
    </adapt-organisation-map-filter>
}

<adapt-organisation-explorer [filterTeams]="filterForTeams"
                             [viewOption]="viewOption"
                             [supplementaryDataVisible]="supplementaryDataVisible"
                             [isEditing]="isEditing"
                             (loaded)="notifyActivated()"></adapt-organisation-explorer>
